import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// WARNING this is LTI AppData only not dashboard AppData
@Injectable({
	providedIn: 'root'
})
export class AppDataService {
	private readonly appDataSubject$ = new BehaviorSubject<any>(null);
	public readonly appData$ = this.appDataSubject$.asObservable();

	public setAppData (data: any): void {
		this.appDataSubject$.next(data);
	}

	public getSnapshot (): any {
		return this.appDataSubject$.getValue();
	}
}
